import type { Plugin } from 'vue'
import { Dayjs, extend, type PluginFunc } from 'dayjs'
import { usePropertyStore } from '~/store/property/property'

declare module 'dayjs' {
  interface Dayjs {
    toPropertyCheckIn(): import('dayjs').Dayjs
    toPropertyCheckOut(): import('dayjs').Dayjs
    toPropertyTimezone(keepLocalTime?: boolean): import('dayjs').Dayjs
  }
}

const toPropertyCheckIn: PluginFunc = (option, dayjsClass) => {
  dayjsClass.prototype.toPropertyCheckIn = function (): Dayjs {
    const propertyStore = usePropertyStore()

    if (!propertyStore.isLoaded) {
      throw new Error('Property must be loaded before using toPropertyCheckIn method')
    }

    return this.hour(propertyStore.checkInFromHours())
      .minute(propertyStore.checkInFromMinutes())
      .second(0)
      .millisecond(0)
  }
}

const toPropertyCheckOut: PluginFunc = (option, dayjsClass) => {
  dayjsClass.prototype.toPropertyCheckOut = function (): Dayjs {
    const propertyStore = usePropertyStore()

    if (!propertyStore.isLoaded) {
      throw new Error('Property must be loaded before using toPropertyCheckIn method')
    }

    return this.hour(propertyStore.checkOutHours())
      .minute(propertyStore.checkOutMinutes())
      .second(0)
      .millisecond(0)
  }
}

const toPropertyTimezone: PluginFunc = (option, dayjsClass) => {
  dayjsClass.prototype.toPropertyTimezone = function (keepLocalTime?: boolean): Dayjs {
    const propertyStore = usePropertyStore()

    if (!propertyStore.isLoaded) {
      throw new Error('Property must be loaded before using toPropertyTimezone method')
    }

    return this.tz(propertyStore.tz(), keepLocalTime)
  }
}

/**
 * Extends packages/fe-core/src/plugins/dayjs.ts
 */
export const configureDayjs: Plugin = {
  install: (): void => {
    extend(toPropertyCheckIn)
    extend(toPropertyCheckOut)
    extend(toPropertyTimezone)
  },
}
